"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _getLogger = _interopRequireDefault(require("./getLogger"));

var _pixelmon = require("./pixelmon");

var logger = (0, _getLogger["default"])('track', 'warn'); // Note to Eko maintainers - the `track` function returns a promise, `imgsLoadedPromiseFromPixelmon`.
// This is being left undocumented for now, but we are using it internally in the redirect service's redirect page
// You can see a test case for this functionality in ekoanalytics-track-promise-api.integration.test.js
// Important that this only covers <img>s loaded for now; <script> loading could be supported in the future,
// but brings in all sorts of complications like async vs sync, scripts that load other scripts,
// what it means for a script to be "loaded" vs "executed", etc

/**
 * Report an event to analytics.
 * You must include the <EkoAnalytics> component on the page prior to calling `track`.
 * @export
 * @method module:utils#track
 * @param {string} event - Name of the event to track.
 * @param {object} [context={}] - Additional data to include.
 */

function track(event) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  logger.debug('[utils/track]::', event, context);
  var imgsLoadedPromiseFromPixelmon = Promise.resolve(); // Since this will be called often from mission-critical app code, I'm making this code super extra careful by wrapping it in try catch
  // Obviously there should never be exceptions thrown from pixelmon, debug, etc etc, but this will just catch them in case we miss something

  try {
    // Always forward the track() to pixelmonInstance - pixelmon handles whether this event should result in a pixel
    imgsLoadedPromiseFromPixelmon = (0, _pixelmon.getPixelmonInstance)().track(event, context);

    if (!window.EkoAnalytics) {
      logger.error("EkoAnalytics not found on window!\nDid you forget to include the <EkoAnalytics /> component on the page?");
      return;
    } // eslint-disable-next-line new-cap


    window.EkoAnalytics('track', event, context);
  } catch (e) {
    logger.error('[utils/track]:: intercepted error from we-sdk! caught', e);
  }

  return imgsLoadedPromiseFromPixelmon;
}

var _default = track;
exports["default"] = _default;